import React from 'react';
import {useAppSelector} from "../DAL/store";
import Gallery from "../../galleries/gallery/gallery";
import {ProductModel} from "../interfaces";
import Imgix from "react-imgix";

export const SubscriptionSlider = () => {

    const PageData = useAppSelector((store) => store.PageData);
    //console.log('SubscriptionSlider: ',PageData.products[0]);
    const ImageCDNDomain= (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();

    return (

            <div id="new" className="bg-dark-blue">
                <div className={`subscription-slider w-full waves-box-xl mx-auto bg-dark-blue bg-none-m text-white pt-4 md:pt-20 pb-20 md:pb-16`}>
                <div className="w-full px-4 md:px-8 lg:px-16 xl:px-0 bg-dark-blue bg-none-m plans-container">
                    <div
                        className="bg-light-blue-2 bg-none-m rounded-2xl flex flex-col  md:flex-row items-stretch justify-start mx-auto">
                        <div className="md:hidden w-full pb-10 md:pb-0">
                            <div className="gradient-border-left-purple-300 pl-3 md:pl-6 xl:ml-1">
                                <div className="line-height-normal text-xl text-white font-montserrat font-bold w-40">
                                    Recently <br/>
                                    Added Plugins
                                </div>
                            </div>
                        </div>
                        <div className="hidden md:flex items-center bg-light-blue rounded-2xl-left px-4">
                            <div className="gradient-border-left-purple-300 pl-3 md:pl-6 xl:ml-1">
                                <div className="line-height-normal text-xl text-white font-montserrat font-bold w-40">
                                    Recently <br/>
                                    Added Plugins
                                </div>
                            </div>
                        </div>
                        <div className="dv-gallery w-full py-1 lg:px-10">
                            <Gallery
                                classes=""
                                galleryStaticContentClasses=""
                                galleryStaticContentArrowClasses="mb-0"
                                galleryRightFadeClasses="right-fade-half"
                                style={{
                                    width: 'auto',
                                }}
                                desktopItemsPerSlide={3.7}
                                tableItemsPerSlide={2.7}
                                mobileItemsPerSlide={1.5}
                                codeName="fmo"
                                items={PageData.products.filter(p => (p.skuInStoreFrom && p.skuInStoreFrom) !== '').sort(function(a:any,b:any){

                                    return new Date(b.skuInStoreFrom).getTime() - new Date(a.skuInStoreFrom).getTime();
                                })}
                                loop={true}
                                duration={800}
                                renderItem={(item: ProductModel, _slideItemWidth: number) => {

                                    return (
                                        <a
                                            className="block no-underline"
                                            href={item.documentUrlPath}
                                            title={item.documentName}
                                            onClick={(evt) => {

                                            }}>
                                            <div className="dv-content flex flex-col items-center ">
                                                <div className="image w-full">
                                                    <Imgix
                                                        src={ImageCDNDomain + item.thumb}
                                                        width={ 600 }
                                                        className="max-w-full"
                                                        htmlAttributes={{
                                                            alt: item.documentName,
                                                            title: item.documentName,
                                                            loading: 'lazy',
                                                        }}
                                                    />
                                                </div>
                                                <div className="description line-height-normal text-white text-center w-full pb-4">
                                                    <span className="font-bold">{item.documentName}</span>
                                                    <br/>
                                                    <span className="text-xs font-normal">Added to </span>
                                                    {
                                                        !!item.isLow && !item.isHigh &&
                                                        <span className="text-xs font-normal">Essential</span>
                                                    }
                                                    {
                                                        !item.isLow && !!item.isHigh &&
                                                        <span className="text-xs font-normal">Ultimate</span>
                                                    }
                                                    {
                                                        !!item.isLow && !!item.isHigh &&
                                                        <span className="text-xs font-normal">Essential & Ultimate</span>
                                                    }
                                                </div>
                                            </div>
                                        </a>
                                    )
                                }}
                            />
                        </div>
                    </div>
                </div>
                </div>
            </div>

    )
};